import { datadogRum as a } from "@datadog/browser-rum";
import { datadogLogs as m } from "@datadog/browser-logs";
import u from "lodash/get";
import { a as l } from "../lib/getAppUrl.zOygEGj2.js";
function _(s) {
  if (s.store.$id !== "auth")
    return;
  if (import.meta.env.VITE_VERSION === void 0) {
    console.warn("Datadog not enabled");
    return;
  }
  let o = 100;
  if (import.meta.env.VITE_DD_LOG_SESSION_SAMPLE !== void 0) {
    const e = parseInt(
      import.meta.env.VITE_DD_LOG_SESSION_SAMPLE,
      10
    );
    o = Number.isNaN(e) || e == null ? o : e;
  }
  let t = 20;
  if (import.meta.env.VITE_DD_RUM_SESSION_SAMPLE !== void 0) {
    const e = parseInt(
      import.meta.env.VITE_DD_RUM_SESSION_SAMPLE,
      10
    );
    t = Number.isNaN(e) || e == null ? t : e;
  }
  let i = 20;
  if (import.meta.env.VITE_DD_RUM_REPLAY_SAMPLE !== void 0) {
    const e = parseInt(
      import.meta.env.VITE_DD_RUM_REPLAY_SAMPLE,
      10
    );
    i = Number.isNaN(e) || e == null ? i : e;
  }
  const p = {
    clientToken: "pubcc051a28aed642c99cd2a9c1bec5f708",
    site: "datadoghq.eu",
    service: l(),
    env: import.meta.env.VITE_STAGE,
    version: import.meta.env.VITE_VERSION,
    trackSessionAcrossSubdomains: !0,
    useSecureSessionCookie: !0
  };
  m.init({
    ...p,
    forwardErrorsToLogs: !0,
    forwardConsoleLogs: "all",
    forwardReports: "all",
    sessionSampleRate: o,
    telemetrySampleRate: 0,
    beforeSend: (e) => {
      if (e.http && e.http.status_code === 0 && e.origin === "network" && e.status === "error")
        return !1;
    }
  }), a.init({
    ...p,
    applicationId: "1156177e-65b0-46c3-8240-98acad2ee6ba",
    sessionSampleRate: t,
    sessionReplaySampleRate: i,
    traceSampleRate: t,
    compressIntakeRequests: !0,
    trackUserInteractions: !0,
    trackResources: !0,
    trackLongTasks: !0,
    defaultPrivacyLevel: "mask-user-input",
    allowedTracingUrls: [/https:\/\/.*\.coactivecare\.co\.uk/]
  });
  function n(e, r) {
    a.setUserProperty(e, r), m.setUserProperty(e, r);
  }
  s.store.$subscribe((e, r) => {
    e.storeId === "auth" && (s.store.isSignedIn === !0 ? (n("id", r.user.id), n("roles", r.user.roles), r.user.profile && n(
      "name",
      `${u(r.user.profile, "firstName").substring(0, 1).toUpperCase()}${u(r.user.profile, "lastName").substring(0, 1).toUpperCase()}`
    )) : (a.stopSession(), a.clearUser(), m.clearUser()));
  });
}
export {
  _ as p
};
